/* eslint-disable */
import { EpgCardDepositActionResult } from "@models/C_Transactions";
import { PaymentsCommonErrorCodes } from "@models/MasterData";
import { PaymentMethodConfig } from "@models/payments/PaymentMethodConfig";
import { ErrorService } from "@providers/ErrorService";
import { TrackingService } from "@providers/TrackingService";
import { UserService } from "@providers/UserService";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { PaymentMethodBehaviour, PaymentMethodBehaviourResult, type SkipAmountResult } from "./PaymentMethodBase";

export class PayValidaCashMethodBehaviourResult extends PaymentMethodBehaviourResult {
  transactionCode: string;
  reference: string;
  amount: number;
  date: string;
}
export class EfectyMethodtBehaviourResul extends PaymentMethodBehaviourResult {
  transactionCode: string;
  reference: string;
  date: string;
  amount: number;
  MFA_CODE: string;
  netAmount: number;
  errCode: number;
  transactionId: string;
  isFirstDeposit: boolean;
  status: string;
  taxAmount: number;
  errMessage: string;
  errorParameters: string;
  declare success: boolean;
}

export abstract class PayValidaCashPaymentMethodBehaviour extends PaymentMethodBehaviour {
  isBank = false;
  minDepositAmount = 30000;
  maxDepositAmount = 99999999;
  amountButtons: number[] = [30000, 100000, 500000, 1000000];
  amount = 30000;
  type: string;
  convenioNumber: string;

  constructor(
    userService: UserService,
    type: string,
    acceptColombiaConditions = false,
    errorService: ErrorService,
    trackingService: TrackingService,
  ) {
    super(acceptColombiaConditions, userService, errorService, trackingService);
    this.type = type;
  }

  skipAmountInput(otherParams: any): Observable<SkipAmountResult> {
    return new Observable<SkipAmountResult>();
  }

  paymentMetodExecution(): Observable<PayValidaCashMethodBehaviourResult> {
    return this.userService
      .validateDepositPayValidaCash(this.amount, this.type, this.acceptColombiaConditions)
      .pipe(
        map((obj) => {
          return this.map(obj);
        }),
        catchError((error, caught) => {
          this.trackCatchError("PayValidaCashPaymentMethod", { err: error, caught: caught });
          return of(<PayValidaCashMethodBehaviourResult>this.getGenericErrorResult());
        }),
      );
  }

  private map(input: EpgCardDepositActionResult): PayValidaCashMethodBehaviourResult {
    const result = new PayValidaCashMethodBehaviourResult();
    if (input.success) {
      const date = new Date();
      const dayOfMonth = date.getDate();
      date.setDate(dayOfMonth + 30);
      const nextMonth = date.getMonth() + 1;

      result.success = true;
      result.amount = input.amount;
      result.transactionCode = input.transactionId;
      result.reference = input.reference;
      result.date =
        date.getDate() +
        " / " +
        (nextMonth.toString().length === 1 ? "0" + nextMonth : nextMonth) +
        " / " +
        date.getFullYear();
    } else {
      this.trackGenericError("PayValidaCashPaymentMethod", result);
      result.success = false;
      result.erroMessage = this.errorService.searchErrorCodeWithParams(
        "error" + input.errCode,
        input.errorParameters,
      );
      result.errorcode = input.errCode;
      result.sendToDocumentVerificationPage =
        input.errCode === PaymentsCommonErrorCodes.MUST_COMPLETE_DOC_VERIFICATION ||
        input.errCode === PaymentsCommonErrorCodes.LIMIT_NOT_VERIFIED_SURPASSED;
      result.acceptColombiaConditionsRequired = input.errCode === 4577; // This code is not on the list from the service /DynTemplateGenCO/Api/Resources/SetLanguageAndGetResources
    }
    return result;
  }
}

export class BalotoPayValidaCashPaymentMethodBehaviour extends PayValidaCashPaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.BALOTO.behaviour;
  name = this.behaviour.name; //"BALOTO"
  image = this.behaviour.image; //"logo_payvalidacash";
  track = this.behaviour.track; //"AccessToPayValidaCash-Baloto";
  constructor(
    public userService: UserService,
    acceptColombiaConditions = false,
    errorService: ErrorService,
    public trackingService: TrackingService,
  ) {
    super(userService, "baloto", acceptColombiaConditions, errorService, trackingService);
  }
}

export class DimonexPayValidaCashPaymentMethodBehaviour extends PayValidaCashPaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.DIMONEX.behaviour;
  name = this.behaviour.name; //"Dimonex"
  image = this.behaviour.image; //"logo_payvalidacash";
  track = this.behaviour.track; //"AccessToPayValidaCash-Dimonex";
  transactionCode: string;
  reference: string;
  declare amount: number;
  date: string;
  constructor(
    public userService: UserService,
    acceptColombiaConditions = false,
    errorService: ErrorService,
    public trackingService: TrackingService,
  ) {
    super(userService, "efecty", acceptColombiaConditions, errorService, trackingService);
  }
}

export class EfectyPaymentMethodBehaviour extends PayValidaCashPaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.EFECTY.behaviour;
  name = this.behaviour.name; //"EEFECTY"
  image = this.behaviour.image; //"logo_payvalidacash";
  track = this.behaviour.track; //"AccessToPayValidaCash-Efecty";
  isBank = this.behaviour.isBank; //false;
  minDepositAmount = 30000;
  maxDepositAmount = 2000000;
  amountButtons: number[] = [30000, 100000, 500000, 1000000, 1500000, 2000000];
  amount = 30000;
  declare type: string;
  MFA_CODE: string;
  netAmount: number;
  errCode: number;
  transactionId: string;
  isFirstDeposit: boolean;
  status: string;
  taxAmount: number;
  errMessage: string;
  errorParameters: string;
  success: boolean;

  constructor(
    public userService: UserService,
    acceptColombiaConditions = false,
    errorService: ErrorService,
    public trackingService: TrackingService,
  ) {
    super(userService, "efecty", false, errorService, trackingService);
  }
}

export class PuntoRedPayValidaCashPaymentMethodBehaviour extends PayValidaCashPaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.PUNTORED.behaviour;
  name = this.behaviour.name; //"PUNTORED"
  image = this.behaviour.image; //"logo_payvalidacash";
  track = this.behaviour.track; //"AccessToPayValidaCash-Puntored";

  constructor(
    public userService: UserService,
    acceptColombiaConditions = false,
    errorService: ErrorService,
    public trackingService: TrackingService,
  ) {
    super(userService, "puntored", acceptColombiaConditions, errorService, trackingService);
  }
}
